import { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { UiCodePIM, imagesContainer, imagesSectionId } from '../../../Constants/Configuration'
import Images from './Images'
import { useAppSelector } from '../../../hooks'
import RenderByProfileOptionWrapper from '../../../Components/Generic/RenderByProfileOptionWrapper'

function ImagesGridLayout({ style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props }, ref) {
  const language = useAppSelector(state => state.present.language.value)
  const fetchedImages = useAppSelector(state => state.present.images.fetchedImages)
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const workspaceImagesVisible = useAppSelector(state => state.present.configuration.workspaceImagesVisible)

  const imageBoxDomElementRef = useRef(null)

  useEffect(() => {
    if (isImagesVisible && workspaceImagesVisible) {
      const imageRef = imageBoxDomElementRef.current
      if (imageRef) {
        imageBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(imageRef)

        return () => {
          imageBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(imageRef)
        }
      }
    }
  }, [props.domElementsRefObserver, imageBoxDomElementRef, isImagesVisible, workspaceImagesVisible])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <RenderByProfileOptionWrapper sectionName={UiCodePIM}>
      <div
        id={imagesSectionId}
        grid-data={props.datagrid}
        className={className + (!fetchedImages || !workspaceImagesVisible ? ' d-none' : '')}
        style={{ ...style }}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className='grid-layout-adjust-wrapper'>
          <div className='drag-handle-grid-container'>
            <DragOutlined />
          </div>
          <div className='diwa-container' ref={imageBoxDomElementRef} id={imagesContainer}>
            <div className={`label-drag`}>{renderTranslation(language, TranslationKeys.buttonImages)}</div>
            <Images />
          </div>
        </div>
      </div>
    </RenderByProfileOptionWrapper>
  )
}

export default forwardRef(ImagesGridLayout)
